<template>
  <div class="scoreResult">
    <el-page-header @back="goBack" content="考试详情" style="margin-bottom: 10px">
    </el-page-header>

    <!-- 基本信息 -->
    <div class="baseInfo">

      <table class="table table-bordered" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td><b>考试</b></td>
          <td colspan="3">{{result.exam_name}}</td>
          <td><b>考试项目</b></td>
          <td>{{result.subject_name}}({{result.case_name}})</td>
        </tr>
        <tr>
          <td><b>姓名</b></td>
          <td colspan="3" id="student">{{student.name}}</td>
          <td><b>评价老师</b></td>
          <td>{{teacher.name}}</td>
        </tr>
        <tr>
          <td><b>答题开始时间</b></td>
          <td colspan="3">{{result.begin_dt}}</td>
          <td><b>耗时</b></td>
          <td colspan="1">{{result.time}}</td>
        </tr>
        <tr>
          <td><b>原始成绩</b></td>
          <td colspan="3">{{result.score}}分</td>
          <td><b>折算成绩</b></td>
          <td>{{result.original_score}}分</td>
        </tr>
        <tr>
          <td><b>评价</b></td>
          <td colspan="5">{{result.evaluate}}</td>
        </tr>
        <tr>
          <td><b>老师签名</b></td>
          <td colspan="5"><img :src="result.teacher_sign" alt="" style="width:100px"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- 打星 -->
    <div>
      <div class="stardiv">
        <label for="">操作的熟练度：</label>
        <i class="el-icon-star-on" v-for="(item,index) in result.patient" :key="index"></i>
      </div>
      <div class="stardiv">
        <label for="">医患沟通技巧：</label>
        <i class="el-icon-star-on" v-for="(item,index) in result.affinity" :key="index"></i>
      </div>
    </div>
    <!-- 折线图 -->
    <div class="chart" id="chart">

    </div>
    <!-- 表格 -->
    <div>

      <ul>
        <div class="tableTit tableTit1">
          <span class="span1">#</span>
          <span class="span2">考核内容</span>
          <span class="span3">总分</span>
          <span class="span4">成绩</span>
        </div>
        <li v-for="(value, key, index) in scores" :key="index" class="">

          <div class="tableTit">
            <span class="span1"> {{index+1}}</span>
            <span class="span2">{{value.content}}</span>
            <span class="span3">{{value.tScore}}分</span>
            <span class="span4">{{value.score}}分</span>
          </div>
          <div>

            <ul>
              <li v-for="(value1, index1) in value.items" :key="index1" class="liitem">
                <span class="span1"> {{index+1}}-{{index1+1}}</span>
                <span class="span2">{{value1.standard.content}}</span>
                <span class="span3">{{value1.score}}分</span>
                <span class="span4">{{value1.standard.score}}分</span>
              </li>
            </ul>

          </div>
        </li>
        <div class="tableTit ">

          <span class="" style="padding-left:10px">特殊评分项：</span>

        </div>
        <li v-for="(value,index3) in specialScore" class="liitem">
          <span class="span1"> {{index3+1}}</span>
          <span class="span2" v-if="value.subject_special_score&&value.subject_special_score.title">{{value.subject_special_score.title}}</span>
          <span class="span3">{{value.score}}分</span>
          <span class="span4" v-if="value.subject_special_score&&value.subject_special_score.title">{{value.subject_special_score.score}}分</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    export default {
        props: {},
        data() {
            return {
                id: this.$route.query.id ?this.$route.query.id: 1,
                xdata: [],//y轴
                ydata1: [],//某个学生的
                ydata2: [],//平均分
                scores: '',
                data: [],
                result: '',
                student: '',
                teacher: '',
                specialScore: [],
            };
        },
        computed: {},
        created() {

        },
        mounted() {
            this.getData();
            window.addEventListener('resize', () => {
                this.$echarts.init(document.getElementById('chart')).resize()
            })

        },
        methods: {
            goBack(){
                this.$router.back();
            },
            // 获取全部的课程列表
            getData() {
                this.$http.detailResult({
                    id: this.id
                })
                    .then(res => {

                        var data = res.data;
                        this.result = data.result
                        this.student = data.result.student
                        this.teacher = data.result.teachers
                        var standard = data.standard;

                        var avg = data.avg;
                        this.scores = data.scores;
                        this.specialScore = data.specialScore

                        var arr = [];
                        for (var i in standard) {

                            this.ydata1.push(standard[i])
                        }

                        for (var i in avg) {

                            this.ydata2.push(avg[i])
                        }
                        for (var i = 0; i < this.ydata2.length; i++) {
                            this.xdata.push("考核点" + (i + 1))
                        }


                        //图表
                        this.getline()

                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            //构建图标
            getline() {
                let chart = this.$echarts.init(document.getElementById('chart'))
                // 绘制图表
                chart.setOption({
                    legend: {
                        data: [this.student.name, '平均分'],
                        right: 10
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    title: {text: '图表分析'},
                    xAxis: {
                        type: 'category',
                        data: this.xdata
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        name: this.student.name,
                        data: this.ydata1,
                        type: 'line',
                        smooth: true,
                        areaStyle: {},
                        markLine: {
                            symbol: ['none', 'none'],
                            label: {show: false},
                            data: [
                                {xAxis: 1},
                                {xAxis: 3},
                                {xAxis: 5},
                                {xAxis: 7}
                            ]
                        },
                    }, {
                        name: '平均分',
                        data: this.ydata2,
                        type: 'line',
                        smooth: true,
                        areaStyle: {},
                        markLine: {
                            symbol: ['none', 'none'],
                            label: {show: false},
                            data: [
                                {xAxis: 1},
                                {xAxis: 3},
                                {xAxis: 5},
                                {xAxis: 7}
                            ]
                        },
                    }
                    ]
                });
            }
        },
    };
</script>

<style lang="less">
  .scoreResult {
    .table-bordered {
      border: 1px solid #ebebeb;
    }

    table {
      display: table;
      border-collapse: separate;

      border-color: grey;
    }

    .table {
      width: 100%;
      max-width: 100%;
      margin-bottom: 20px;
      border-spacing: 0;
      border-collapse: collapse;
      empty-cells: show;
    }

    .table > tbody > tr > td,
    .table > tbody > tr > th,
    .table > tfoot > tr > td,
    .table > tfoot > tr > th,
    .table > thead > tr > td,
    .table > thead > tr > th {
      border-top: 1px solid #e7eaec;
      line-height: 1.42857;
      padding: 8px;
      vertical-align: middle;
    }

    .table-bordered > tbody > tr > td,
    .table-bordered > tbody > tr > th,
    .table-bordered > tfoot > tr > td,
    .table-bordered > tfoot > tr > th,
    .table-bordered > thead > tr > td,
    .table-bordered > thead > tr > th {
      border: 1px solid #e7e7e7;
    }

    .stardiv {
      margin-bottom: 10px;

      label {
        font-weight: bold;
        font-size: 14px;
      }

      i {
        font-weight: normal;
        font-size: 18px;
      }
    }

    .chart {
      width: 100%;
      height: 500px;
      margin-right: 40px;
    }

    .tableTit {
      line-height: 40px;
      height: 40px;
      background: #ccc;

      overflow: hidden;
    }

    .tableTit1 {
      font-weight: bold;
      background: #fff;
    }

    .liitem {
      line-height: 40px;
      height: 40px;
      border-bottom: 1px solid #ccc;
      overflow: hidden;
    }

    .span1 {
      width: 10%;
      float: left;
      padding-left: 10px;
      box-sizing: border-box;
    }

    .span2 {
      width: 70%;
      float: left;
    }

    .span3 {
      width: 10%;
      float: left;
    }

    .span4 {
      width: 10%;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/examManage/scoreResult.vue